import React from 'react';
import { CustomModal } from '../../../../common/CustomModal';
import '../../../../../styles/components/bidders-list.scss'; // reuse styles, or make an auctions-list.scss
import { formatAmount, formatNumber } from '../../../../../utils/common';
import { Gavel } from 'lucide-react';
import i18n from '../../../../../i18n';

export class AuctionsListModal extends React.Component {
  handleCancel = () => {
    this.props.onClose();
  };

  render() {
    const { show, auctions = [] } = this.props;
    const isArabic = i18n.language === 'ar';

    return (
      <CustomModal isOpen={show} header={i18n.t('auctions_list')} onClose={this.handleCancel}>
        <div className="bidders-container">
          {auctions.length === 0 ? (
            <div className="no-bidders">
              <p>{i18n.t('no_auctions_available')}</p>
            </div>
          ) : (
            <div className="bidders-list">
              {auctions.map((auction, index) => (
                <div key={auction.id} className="bidder-card">
                  <div className="bidder-rank">
                    <span className="rank-badge rank-other">#{index + 1}</span>
                  </div>

                  <div className="bidder-content">
                    <div className="bidder-avatar-section">
                      <div className="bidder-avatar">
                        <Gavel size={16} strokeWidth={1.5} />
                      </div>
                      <div className="bidder-info">
                        <h3 className="bidder-name">
                          {isArabic ? auction.title_ar || auction.title : auction.title}
                        </h3>
                        <div className="bidder-meta">
                          <span className="bidder-id">
                            {i18n.t('auction_id')}:
                            {formatNumber(auction.id, isArabic ? 'ar-EG-u-nu-arab' : 'en-US')}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="bidder-amount-section">
                      <div className="bid-amount">
                        {formatAmount(
                          auction.guarantee_amount,
                          isArabic ? 'ar-OM-u-nu-arab' : 'en-US'
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {auctions.length > 0 && (
            <div className="bidders-footer">
              <p>
                {i18n.t('total_auctions')} <strong>{auctions.length}</strong>
              </p>
            </div>
          )}
        </div>
      </CustomModal>
    );
  }
}
